import { SafeHtml } from '@angular/platform-browser';

export interface HorizontalListData {
  itemType?: HorizontalListItemType;
  customItemTemplateName?: string;
  titleData?: HorizontalListOptionData;
  valueData?: HorizontalListOptionData;
  isItemHidden?: boolean;
  hideDividerBelow?: boolean;
  itemSize?: HorizontalListItemSize;
}

export interface HorizontalListOptionData {
  optionType: HorizontalListOptionType;
  displayedValue?: string | SafeHtml;
  routerLink?: string;
  externalLink?: string;
  actionName?: string;
  customTemplateName?: string;
  isOptionHidden?: boolean;
  tooltipMessage?: string;
}

export enum HorizontalListItemType {
  TitleValue = "titleValue",
  Info = "info",
  Custom = "custom"
}

export enum HorizontalListItemSize {
  Default = "default",
  Small = "small",
  ExtraSmall = "extraSmall",
}

export enum HorizontalListOptionType {
  String = "string",
  RouterLink = "routerLink",
  ExternalLink = "externalLink",
  CustomTemplate = "customTemplate"
}

export interface HorizontalFactoryBaseItem {
  isItemHidden?: boolean;
  itemSize?: HorizontalListItemSize;
  hideDividerBelow?: boolean;
}

export interface HorizontalFactoryKeyValueBaseItem extends HorizontalFactoryBaseItem {
  title: string;
}
